import React, { useEffect, useState } from 'react';
import { getFiles } from '../../../hooks/api-methods/get-upload';
import Loader from '../../../components/Loader/Loader';
import MyMasonry from '../../../components/Mansory/Mansory';

interface FileItem {
  name: string;
  url: string;
}

interface UploadsListViewProps {
  selectMode?: boolean; // Enable multi-select
  selectedImages?: string[];
  onSelect?: (url: string) => void;
}

const UploadsListView: React.FC<UploadsListViewProps> = ({
  selectMode,
  selectedImages = [],
  onSelect,
}) => {
  const [files, setFiles] = useState<FileItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  async function fetchFiles() {
    try {
      setLoading(true);
      setError(null);
      const result = await getFiles('uploads');
      setFiles(result);
    } catch (err) {
      if (err instanceof Error) setError(err.message);
      else setError('Er is een onbekende fout opgetreden.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchFiles();
  }, []);

  const handleSelectImage = (url: string) => {
    if (!selectMode || !onSelect) return;
    onSelect(url);
  };

  if (loading) return <Loader />;
  if (error) return <p className="flex-row-align justify-center w-100 vh-75">{error}</p>;
  if (files.length === 0) return <p className="w-100 vh-75">Geen bestanden gevonden.</p>;

  return (
    <div className="ptb-2 relative">
      <MyMasonry
        items={files}
        renderItem={(file) => {
          const isSelected = selectedImages?.includes(file.url);

          return (
            <div
              key={file.url}
              className={`file-item ${selectMode && isSelected ? 'selected' : ''}`}
              onClick={() => handleSelectImage(file.url)}
              style={{ position: 'relative', cursor: selectMode ? 'pointer' : 'default' }}
            >
              {file.url.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                <img className="selected-image" src={file.url.trim()} alt={file.name} />
              ) : (
                <a
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 underline"
                >
                  {file.name}
                </a>
              )}

              {selectMode && isSelected && (
                <span
                  className="selected-badge"
                  style={{
                    position: 'absolute',
                    top: 5,
                    right: 5,
                    background: 'green',
                    color: 'white',
                    borderRadius: '50%',
                    width: 20,
                    height: 20,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  ✓
                </span>
              )}
            </div>
          );
        }}
      />
    </div>
  );
};

export default UploadsListView;
